import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const NavBarSkeleton = () => (
  <div className="skeleton-navbar">
    <SkeletonCircle size={32} />
    <SkeletonText widths={['100px']} lineHeight="20px" />
  </div>
);

const FinanceSkeleton = () => {
  return (
    <div aria-hidden="true">
      <NavBarSkeleton />
      <div className="skeleton-finance">
      {/* Header */}
      <div className="skeleton-finance__header">
        <SkeletonText widths={['180px']} lineHeight="28px" />
        <SkeletonBox width={100} height={40} borderRadius="var(--radius-md)" />
      </div>

      {/* Summary cards */}
      <div className="skeleton-finance__cards">
        {[1, 2, 3, 4].map((card) => (
          <div key={card} className="skeleton-finance__card">
            <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)', marginBottom: 'var(--space-md)' }}>
              <SkeletonCircle size={24} />
              <SkeletonText widths={['80px']} lineHeight="14px" />
            </div>
            <SkeletonText widths={['100px']} lineHeight="28px" />
            <SkeletonText widths={['60px']} lineHeight="12px" style={{ marginTop: '4px' }} />
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div className="skeleton-finance__tabs">
        {['Revenue', 'Budget', 'Advertising', 'AI Insights', 'AI Agent'].map((tab) => (
          <SkeletonBox
            key={tab}
            width={80}
            height={36}
            borderRadius="var(--radius-sm)"
          />
        ))}
      </div>

      {/* Tab content */}
      <div className="skeleton-finance__content">
        <SkeletonText widths={['150px']} lineHeight="20px" style={{ marginBottom: 'var(--space-lg)' }} />
        <SkeletonBox height={250} borderRadius="var(--radius-md)" />
      </div>
      </div>
    </div>
  );
};

export default FinanceSkeleton;
